import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getQueryMinTripadvisorRating } from 'store/search/searchSelectors/querySelectors';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';
import TripadvisorRatingFilter from 'components/Filters/Search/RatingFilter/TripadvisorRatingFilter';

import FilterItem from './FilterItem';

const TripadvisorRatingFilterItem = () => {
  const dispatch = useDispatch();
  const minTripadvisorRating = useSelector(getQueryMinTripadvisorRating);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ minTripAdvisorRating: undefined });
  }, [updateQuery]);

  return (
    <FilterItem buttonText="Guest Rating" isHighlighted={!!minTripadvisorRating} clearFilters={clearFilters}>
      <TripadvisorRatingFilter onChange={updateQuery} />
    </FilterItem>
  );
};

export default TripadvisorRatingFilterItem;
